<div class="btn-group">
    <ng-content></ng-content>
    <save-button (click)="doSave()" [disabled]="!canSave"></save-button>
    <cancel-button></cancel-button>
</div>
